import React, { useState } from 'react'
import { getDesc, reframePlanetData } from '../function/function';

function MoonDetails(props) {
    const planet = reframePlanetData(props.planet)

    // State:
    const [hoverDesc, setHoverDesc] = useState("")
    const [displayAttr, setDisplayAttr] = useState(null)

    const toggleDisplayAttr = (index) => {
        if (displayAttr === index) {
          setDisplayAttr(null); // Disable the currently active object
        } else {
          setDisplayAttr(index); // Enable the clicked object
        }
    };
  return (
    <div>
        <div className="planet_moon_info_main_div">
              <div>
                <p className="planet_main_desc">
                  {planet.name}'s Moon
                </p>
              </div>

              <div className="planet_moon_main_scroll_div">
              { planet.satellite.map(i => 
                (
                  <div>
                      <div>
                        <div className="planet_object_property_title" onClick={() => toggleDisplayAttr(i.name)}>
                          <p>{i.name}</p>
                          <p>{displayAttr === i.name ? "-" : "+"}</p>
                        </div>

                        {displayAttr ===  i.name && <div className="planet_object_property_scroll">
                          { Object.keys(i).map(attr => (
                              <p className="planet_object_property_attr"><span onMouseEnter={() => setHoverDesc(getDesc(attr))}>{attr}:</span> {i[attr]}
                                <div className="planet_property_attr_hover">
                                    <p className="planet_property_attr_hover_desc">{hoverDesc}</p>
                                </div>
                              </p>
                            ))
                          }
                        </div>
                        }
                      </div>
                    
                  </div> 
                ))
              }
              </div>
            </div>
    </div>
  )
}

export default MoonDetails